export default "__VITE_ASSET__CLvUqd$Y__"